<template>
	<div class="rejoin rejoin-container container border-l">
		<h3>You left game {{ localMock.roomCode }}</h3>
		<h4>Would you like to rejoin?</h4>
		<primary-button @click="handleReconnect" class="mt-8 full-width"
			>Rejoin now</primary-button
		>
	</div>
</template>

<script>
import PrimaryButton from "./PrimaryButton";
import { mapGetters, mapActions } from "vuex";
export default {
	components: {
		PrimaryButton,
	},
	computed: {
		...mapGetters(["mockingLocal", "localMock", "local"]),
		localPayload() {
			return this.mockingLocal
				? {
						aRoomCode: this.localMock.roomCode,
						aLocalId: this.localMock.socketId,
				  }
				: {
						aRoomCode: this.local.roomCode,
						aLocalId: this.local.socketId,
				  };
		},
	},
	methods: {
		...mapActions(["tryReconnectToGame"]),
		handleReconnect() {
			this.tryReconnectToGame(this.localPayload);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/main.scss";

.rejoin-container {
	h3 {
		font-weight: bold;
	}
	padding: 24px;
	position: absolute;
	z-index: 1000;
	min-width: 320px;
	max-width: 440px;
	bottom: 16px;
	left: 16px;
}
</style>
